module.exports = __webpack_public_path__ + "static/media/19.697a78fd.png";